import { IAutomationObject } from '../../types'

export interface IFG_CoolingControl extends IAutomationObject {

}

export const schema = 'AutomationApps.FunctionGroups.CoolingControls.FG_CoolingControl';

 